export enum AccountDormantByStatuses {
  UNSET = 'UNSET',
  DORMANT_DATE = 'DORMANT_DATE',
  STATUS_CODE = 'STATUS_CODE',
  STATUS_CODE_OR_DORMANT_DATE = 'STATUS_CODE_OR_DORMANT_DATE',
  STATUS_CODE_AND_DORMANT_DATE = 'STATUS_CODE_AND_DORMANT_DATE',
}

export default AccountDormantByStatuses;
